import React from 'react';

const PatientData = (props) => {
  return (
    <tr>
      <td>{props.id}</td>
      <td>{props.IIN}</td>
      <td>{props.FIO}</td>
      <td>{props.regDate}</td>
      <td>{props.diagnosis}</td>
      <td>{props.severity}</td>
    </tr>
  );
};
export default PatientData;
